<style scoped>
    @import url("../../styles/loraPub/loraPup.scss");
</style>

<template>
    <div class="box_loraPub" v-if="!$store.state.flagMenuSup">

        <div class="line_btnToBack mt-4" @click="backToMain()"
        @mouseover="hoverBackInit = 'rgb(31,122,177)'"
        @mouseleave="hoverBackInit = '#f39c12'"
        >
            <v-icon large class="mr-2" :style="{'color':hoverBackInit}">mdi-arrow-left-thick</v-icon>
            <span>Voltar</span>
        </div>

        <!-- Informações lorawan geral -->
        <InfoLoraInitPage />

        <!-- Título -->
        <div class="tit_ex mt-8 mb-8">
            <ImgLOGO />
            <div class="el_tit_ex mt-4">Rede LoRaWAN - Município do Fundão - Portugal - 2024 - 2025</div>
        </div>

        <!-- LOADING MAPA -->
        <div v-if="flagLoadingSinal" class="mb-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="160"
                indeterminate
                :style="{'display':'flex','align-items':'center','justify-content':'center'}"
            >
                <span :style="{'font-size':'0.7rem','width':'60%'}">
                    Aguarde <br>
                    enquanto montamos <br>
                    o seu mapa
                </span>
            </v-progress-circular>
        </div>

        <!-- MAPA -->
        <PontosLoraPub class="" :listaCoords="listaCoords" v-if="!flagLoadingSinal" />

        <!-- "gambiarra"  de sobreposição de elementos na página LARGE -->
        <div class="segunda_linha hidden-sm-and-down mb-16">
            <div class="sobreposta"></div>
        </div>

        <!-- "gambiarra"  de sobreposição de elementos na página SMALL -->
        <div class="segunda_linha_small hidden-md-and-up mb-16">
            <div class="sobreposta_small"></div>
        </div>

    </div>
</template>

<script>
import InfoLoraInitPage from './InfoLoraInitPage'
import PontosLoraPub from './PontosLoraPub.vue'
import ImgLOGO from './ImgLOGO'

import axios from 'axios'

export default {

    components: { InfoLoraInitPage, PontosLoraPub, ImgLOGO },

    data() {
        return {
            // op map
            listaCoords:[], // ---> props ---> child map
            flagLoadingSinal:true,

            // btn voltar
            hoverBackInit:'#f39c12', // -- init laranja
        }
    },

    methods: {
        //
        backToMain() { this.$router.push('/'); },

        preInit() {

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this
            
            let params = { 'marcador': self.$store.state.markPub }

            let url = self.$store.state.pathAxiosBASE + '/mappointslorawanx' // concat

            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                self.listaCoords = res.data.result // liP
                if (self.listaCoords.length > 0) { self.flagLoadingSinal = false } // lista map sinal ok
            })
        },
    },

    created() {
        this.$store.commit('init') // despertar api.
        this.preInit()

        /*
        // -- req mapa de pontos.
        var self = this
        
        axios.get(self.$store.state.pathAxiosGetLora).then(function (res) {
            //console.log('RCV FROM testerConV4')
            //console.log(res.data.result)
            self.listaCoords = res.data.result //.liP
            //self.listaGw = res.data.result.liGw
            //self.listaCirc = res.data.result.liCirc
            
            if (self.listaCoords.length > 0) { self.flagLoadingSinal = false } //lista map sinal ok
            //self.flagLoadingSinal = true // tmp manutenção fev25
        })
        */
    }
}
</script>